import { useEffect, useState } from "react";
import axios from "axios";

const useCMSApi = () => {
  const apiBaseUrl = process.env.REACT_APP_API_PATH;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const [pages, setPages] = useState([])
  useEffect(() => {
    const fetchPages = async () => {
      try {
        const response = await axios.get(`${apiBaseUrl}/pages/getdata`);
        setPages(response.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to load pages");
        setLoading(false);
      }
    };
    fetchPages();
  }, [apiBaseUrl]);
  return { pages, loading, error };
};

export default useCMSApi;
